import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { TRANSACTION_LIST_COLUMN_LABEL_I18N_KEY } from '../transaction-list/transaction-list.config';
import { useTransactionListContext } from '../transaction.context';

export const TransactionListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useTransactionListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={TRANSACTION_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
